import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, MenuItem, Switch, TextField } from "@mui/material";
import { menuApi } from "../utils/menuApi";

const defaultForm = {
  name: "",
  is_available: true,
  pickup: "",
  delivery: "",
  dine_in: "",
  discount_type: "",
  discount_value: "",
  badge: "",
  display_order: 1,
};

const VariantDialog = ({
  open, mode, data, variantType, token, clientId, locationId,
  foodType, category, item, variantGroup, onClose, onSuccess, showSnackbar,
}) => {
  const [form, setForm] = useState(defaultForm);

  useEffect(() => {
    if (data) {
      setForm({
        name: data.name || "",
        is_available: data.is_available ?? true,
        pickup: data.pricing?.pickup ?? "",
        delivery: data.pricing?.delivery ?? "",
        dine_in: data.pricing?.dine_in ?? "",
        discount_type: data.discount_type || "",
        discount_value: data.discount_value ?? "",
        badge: data.badge || "",
        display_order: data.display_order ?? 1,
      });
    } else {
      setForm(defaultForm);
    }
  }, [data, open]);

  const payload = {
    name: form.name,
    is_available: form.is_available,
    pricing: {
      pickup: form.pickup === "" ? null : Number(form.pickup),
      delivery: form.delivery === "" ? null : Number(form.delivery),
      dine_in: form.dine_in === "" ? null : Number(form.dine_in),
    },
    discount_type: form.discount_type || "",
    discount_value: form.discount_value === "" ? null : Number(form.discount_value),
    badge: form.badge || "",
    display_order: Number(form.display_order || 1),
  };

  const handleSave = async () => {
    try {
      if (variantType === "group") {
        if (mode === "edit" && data?.id) {
          await menuApi.updateVariantInGroup({
            token, clientId, locationId,
            foodTypeId: foodType.id,
            categoryId: category.id,
            itemId: item.id,
            variantGroupId: variantGroup.id,
            variantId: data.id,
            payload,
          });
          showSnackbar("Variant updated successfully");
        } else {
          await menuApi.createVariantInGroup({
            token, clientId, locationId,
            foodTypeId: foodType.id,
            categoryId: category.id,
            itemId: item.id,
            variantGroupId: variantGroup.id,
            payload,
          });
          showSnackbar("Variant created successfully");
        }
      } else {
        if (mode === "edit" && data?.id) {
          await menuApi.updateDirectVariant({
            token, clientId, locationId,
            foodTypeId: foodType.id,
            categoryId: category.id,
            itemId: item.id,
            variantId: data.id,
            payload,
          });
          showSnackbar("Direct variant updated successfully");
        } else {
          await menuApi.createDirectVariant({
            token, clientId, locationId,
            foodTypeId: foodType.id,
            categoryId: category.id,
            itemId: item.id,
            payload,
          });
          showSnackbar("Direct variant created successfully");
        }
      }
      onSuccess();
      onClose();
    } catch (error) {
      showSnackbar(error?.response?.data?.detail || "Failed to save variant", "error");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {mode === "edit" ? "Edit Variant" : `Add ${variantType === "group" ? "Grouped" : "Direct"} Variant`}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12}><TextField fullWidth label="Name" value={form.name} onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))} /></Grid>
          <Grid item xs={12} sm={4}><TextField fullWidth type="number" label="Pickup Price" value={form.pickup} onChange={(e) => setForm((p) => ({ ...p, pickup: e.target.value }))} /></Grid>
          <Grid item xs={12} sm={4}><TextField fullWidth type="number" label="Delivery Price" value={form.delivery} onChange={(e) => setForm((p) => ({ ...p, delivery: e.target.value }))} /></Grid>
          <Grid item xs={12} sm={4}><TextField fullWidth type="number" label="Dine-in Price" value={form.dine_in} onChange={(e) => setForm((p) => ({ ...p, dine_in: e.target.value }))} /></Grid>
          <Grid item xs={12} sm={6}>
            <TextField select fullWidth label="Discount Type" value={form.discount_type} onChange={(e) => setForm((p) => ({ ...p, discount_type: e.target.value }))}>
              <MenuItem value="">None</MenuItem>
              <MenuItem value="flat">Flat</MenuItem>
              <MenuItem value="percentage">Percentage</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}><TextField fullWidth type="number" label="Discount Value" value={form.discount_value} onChange={(e) => setForm((p) => ({ ...p, discount_value: e.target.value }))} /></Grid>
          <Grid item xs={12} sm={6}><TextField fullWidth label="Badge" value={form.badge} onChange={(e) => setForm((p) => ({ ...p, badge: e.target.value }))} /></Grid>
          <Grid item xs={12} sm={3}><TextField fullWidth type="number" label="Display Order" value={form.display_order} onChange={(e) => setForm((p) => ({ ...p, display_order: e.target.value }))} /></Grid>
          <Grid item xs={12} sm={3}><FormControlLabel control={<Switch checked={form.is_available} onChange={(e) => setForm((p) => ({ ...p, is_available: e.target.checked }))} />} label="Available" /></Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default VariantDialog;